import React, { useEffect, useState } from 'react'
import { fechaActual } from '../../../hooks/UseDate'
import { getTipoDocumentoDespachoQxFarmacia, postDataDevolucionesQx, postDespachoQxBodegaFarmacia, postEstadoPaqueteFarmacia, postEstadosDelDespachoDevolucionQxFarmacia, postQuirofanosFarmacia } from '../../../services/FarmaciaRuta'
import Loading from '../../Loading'
import ModalListaPersonalEnfermeriaDevolucionesQx from './ModalListaPersonalEnfermeriaDevolucionesQx'
import TablaDevolucionesQxFarmacia from './TablaDevolucionesQxFarmacia'
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { UserTokenURL } from '../../../services/ApiHIS'


const DevolucionesQxFarmacia = () => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [loading,setloading]=useState(false)
  const [dataDevoluciones,setdataDevoluciones]=useState([])
  //const [dataBodega,setdataBodega]=useState([])
  const [dataQuirofanos,setdataQuirofanos]=useState([])
  const [dataTipoDocumento,setdataTipoDocumento]=useState([])
  const [validarEnfermeria,setvalidarEnfermeria]=useState('')
  const [modalOnListaPersonalEnfermeria,setmodalOnListaPersonalEnfermeria]=useState(false)
  const [dataEstadosDespachados,setdataEstadosDespachados]=useState([])
  const [dataEstadoPaquete,setdataEstadoPaquete]=useState([])
  const [actualizarDataTable, setactualizarDataTable]=useState([])
  const [dataEnfermeria, setdataEnfermeria]=useState({
    idEnfermeria: '',
    nombreEnfermeria: ''
  })

  //token
  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get('token'));
  let location = useLocation();
  useEffect(() => {
    // Google Analytics
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

  //actualizar la tabla apenas se haga una devolucion de un suministro
  const actualizarData=(data)=>{
    setactualizarDataTable(data)
  }

  //obtener la data de enfermeria de la tabla
  const passDataEnfermeria=(data)=>{
    setdataEnfermeria(data)
    setvalidarEnfermeria('')
  }

  //cerrar modal
  const handleOnclickListaPersonalEnfermeria=()=>{
    setmodalOnListaPersonalEnfermeria(true)
  }

  //Filtros de busqueda
  const handleOnsubmitBuscarDevoluciones=(e)=>{
    e.preventDefault()
    setloading(false)
    const dataDevoluciones={
      ProFec: e.target.fechaInicial.value,
      ProEmpCod:usuarioInfo.Empresa,
      ProSedQr:usuarioInfo.Sede,
      ProFecF: e.target.fechaFinal.value,
      MPCedu: e.target.numeroDocumento.value,
      MPNOMC: e.target.nombrePaciente.value,
      PqEdoGas: e.target.estadoDiligenciado.value,
      PQEdoDes: e.target.estadoDespachoSelect.value,
      ConsCod: e.target.quirofanosSelect.value
    }
    console.log(dataDevoluciones,'dataDevolucionesdataDevolucionesdataDevoluciones')
    postDataDevolucionesQx(dataDevoluciones).then((res)=>{
      console.log(res.data,'dataprincipal')
      setdataDevoluciones(res.data)
      setTimeout(() => {          
        setloading(true)
      }, 3000);
    })
  }
  useEffect(()=>{
    setloading(false)
    setvalidarEnfermeria('Ingresar la persona que devuelve')
    const quirofanos={
      EMPCOD:usuarioInfo.Empresa,
      ConsTpo:'QR',
      MCDpto:usuarioInfo.Sede
    }
    postQuirofanosFarmacia(quirofanos).then((res)=>{
      //console.log(res.data,'quiro')
      setdataQuirofanos(res.data)
    })
    getTipoDocumentoDespachoQxFarmacia().then((res)=>{
      setdataTipoDocumento(res.data)
    })
    // const bodega={
    //   EMPCOD:usuarioInfo.Empresa,
    //   AUsrId:'HOSVITAL',
    //   BodDspPis:'S',
    //   MCDpto:usuarioInfo.Sede
    // }
    // postDespachoQxBodegaFarmacia(bodega).then((res)=>{
    //   console.log(res.data,'bodega')
    //   setdataBodega(res.data)
    // })
    
    ///estado del despacho
    const estadoDespacho={
      ProEmpCod:usuarioInfo.Empresa,
      ProMCDpto:usuarioInfo.Sede
    }
    postEstadosDelDespachoDevolucionQxFarmacia(estadoDespacho).then((res)=>{
      console.log(res.data,'estados despachos')
      setdataEstadosDespachados(res.data)
    })
    postEstadoPaqueteFarmacia(estadoDespacho).then((res)=>{
      console.log(res.data,'data paquete')
      setdataEstadoPaquete(res.data)
    })

  },[])

  useEffect(()=>{
    const dataDevoluciones={
      ProFec: `${fechaActual()}`,
      ProEmpCod:usuarioInfo.Empresa,
      ProSedQr:usuarioInfo.Sede,
      ProFecF:`${fechaActual()}`,
      MPCedu:'',
      MPNOMC:'',
      PQEdoDes: ''
    }
    postDataDevolucionesQx(dataDevoluciones).then((res)=>{
      console.log(res.data,'dataprincipal')
      setTimeout(() => {
          
        setloading(true)
      }, 2000);
      setdataDevoluciones(res.data)
      
    })
  },[actualizarDataTable])

  //token
  useEffect(()=>{
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL() 

    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };

    // Realiza la petición con Axios
    axios.get(url, { headers })
    .then(response => {
      //console.log(response.data.user_data, 'data user');

      // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
      localStorage.removeItem('usuarioInfo');
      console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
      // Guarda los nuevos datos
      localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

      //console.log(localStorage.getItem('usuarioInfo'),'antessss')
      // Comprobación de los datos almacenados
      const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
      console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr')

      // Resto del código...
    })
    .catch(error => {
      console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
    });
  },[])
  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#9e56fe] font-medium pb-3">
          Devoluciones de Cirugía
        </div>
        <div className="text-center bg-[#9e56fe] pb-1">
            <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
                >
                  Seleccionar Persona Quien Devuelve
            </label>
          </div>
        <form onSubmit={handleOnsubmitBuscarDevoluciones}>
            <div className="flex flex-row py-1  text-left">
              <div className="w-1/3  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Devuelve
                </label>
                <input
                  onFocus={handleOnclickListaPersonalEnfermeria}
                  defaultValue={dataEnfermeria.idEnfermeria}
                  //disabled={true}
                  //defaultValue={dataUser.MPCedu}
                  autoComplete='off'
                  name="cedulaPaciente"
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
                <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                  {validarEnfermeria}
                </label>
              </div>
              <div className="w-1/3  px-1 pt-2">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium "></label>
                <input
                  //disabled={true}
                  //defaultValue={dataUser.MPTDoc}
                  defaultValue={dataEnfermeria.nombreEnfermeria}
                  disabled={true}
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
              
            </div>
            <div className="text-center bg-[#9e56fe] pb-1">
            <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
                >
                  Filtros de Búsqueda
            </label>
          </div>
            <div className="flex flex-row py-1  text-left">
            <div className="w-1/3  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Número Documento
                </label>
                <input
                  //disabled={true}
                  //defaultValue={nameUser.MPNOMC}
                  name="numeroDocumento"
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
              <div className="w-1/3  px-1 ">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label inline-block mb-2 text-gray-900 font-medium"
                >
                  Tipo Documento
                </label>

                <select
                  //disabled={true}
                  name="documentoSelect"
                  className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                  aria-label="Default select example"
                >
                  
                  {
                    dataTipoDocumento.map((item)=>(
                      <option value={item.MPTDoc} key={item.MPTDoc}>
                      {item.MPTDoc}
                    </option>
                    ))
                  }
                </select>
              </div>

              <div className="w-1/3  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Nombre
                </label>
                <input
                  //disabled={true}
                  //defaultValue={nameUser.MPNOMC}
                  name="nombrePaciente"
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
            </div>
            <div className="flex flex-row py-1  text-left">
              <div className="w-1/3  px-1 ">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label inline-block mb-2 text-gray-900 font-medium"
                >
                  Sala
                </label>

                <select
                  //disabled={true}
                  name="quirofanosSelect"
                  className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                  aria-label="Default select example"
                >
                  <option value=''>Todos</option>
                  {
                    dataQuirofanos.map((item)=>(
                      <option value={item.ConsCod} key={item.ConsCod}>
                      {item.ConsDet}
                    </option>
                    ))
                  }
                </select>
              </div>
              {/* <div className="w-1/3  px-1 ">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label inline-block mb-2 text-gray-900 font-medium"
                >
                  Bodega destino
                </label>

                <select
                  //disabled={true}
                  name="estadosSelect"
                  className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                  aria-label="Default select example"
                >
                  {dataBodega.map((item) => (
                    <option value={item.BODEGA} key={item.BODEGA}>
                      {item.BODEGA}- {item.BODDESC}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="w-1/3  px-1 ">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label inline-block mb-2 text-gray-900 font-medium"
                >
                  Estado diligenciado
                </label>

                <select
                  //disabled={true}
                  name="estadoDiligenciado"
                  className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                  aria-label="Default select example"
                >
                  <option value=''>Todos</option>
                  <option value="S">Sin diligenciar</option>
                  <option value="P">Parcialmente diligenciado</option>
                  <option value="D">Diligenciado</option>
                  {/* {dataEstadoPaquete.map((item) => (
                    <option value={item.PqEdoGas} key={item.PqEdoGas}>
                      {item.PqEdoGas}
                    </option>
                  ))} */}
                </select>
              </div>
              <div className="w-1/3  px-1 ">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label inline-block mb-2 text-gray-900 font-medium"
                >
                  Estado Despacho
                </label>

                <select
                  //disabled={true}
                  name="estadoDespachoSelect"
                  className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                  aria-label="Default select example"
                >
                  <option value=''>Todos</option>
                  {/* <option value='V'>Por Devolver</option> */}
                  <option value='P'>Pendiente Despacho</option>
                  <option value='R'>Despacho Parcial</option>
                  <option value='D'>Despachado</option>    
                  <option value='V'>Devuelto</option>              
                  <option value='C'>Cancelado</option>
                  
                  {/* {dataEstadosDespachados.map((item) => (
                    <option value={item.PQEdoDes} key={item.PQEdoDes}>
                      {item.PQEdoDes}
                    </option>
                  ))} */}
                </select>
              </div>
              
              
            </div>
            <div className="flex flex-row py-1  text-left">
              <div className="w-1/3  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Fecha Inicial
                </label>
                <input
                  //onChange={handleOnChangeFechaInicial}
                  name="fechaInicial"
                  defaultValue={fechaActual()}
                  type="date"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
                <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                  {/* {errorFechaInicial} */}
                </label>
              </div>
              <div className="w-1/3  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Fecha Final
                </label>
                <input
                  //onChange={handleOnChangeFechaFinal}
                  name="fechaFinal"
                  defaultValue={fechaActual()}
                  type="date"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
                <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                  {/* {errorFechaFinal} */}
                </label>
              </div>
              <div className="mt-8">
                <button
                  //onClick={handleOnclickModalOnProgramacionDeCirugia}
                  type="submit"
                  className="inline-block px-4 py-2 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Buscar
                </button>
              </div>

              {/* <div className="w-1/3  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Nombre
                </label>
                <input
                  //disabled={true}
                  //defaultValue={nameUser.MPNOMC}
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div> */}
            </div>
            
          </form>
          <div className="flex py-2 text-left">
                
                {/* <div className="w-1/3  px-1 flex">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Con pendientes por devolver
                  </label>
                  <div className="px-2">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={informacionUser.MPCedu}
                      //name="especialidadMedico"
                      disabled={true}
                      type="text"
                      autoComplete="off"
                      className="form-control block w-20 px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#fef9c3] bg-clip-padding    transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    
                  </div>
                </div> */}
                <div className="w-1/3  px-1 flex">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Suministros que faltan por devolver
                  </label>
                  <div className="px-3">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={informacionUser.MPNOMC}
                      //name="especialidadMedico"
                      disabled={true}
                      type="text"
                      autoComplete="off"
                      className="form-control block w-20 px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#bbf7d0] bg-clip-padding    transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    {/* <button
                      type="submit"
                      className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Buscar
                    </button> */}
                  </div>
                </div>
              </div>
        
              <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                    <th
                        scope="col"
                        className=""
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Uso
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        N°
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Docu
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Identificación
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Paciente
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Paquete
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Descripción
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Sala de cirugía
                      </th>
                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Cirugía Fecha
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Sede Reserva cirugia
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Empresa reserva cirugia
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Estado
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Bodega Qx
                      </th>
                    </tr>
                  </thead>
                  {loading?
                    dataDevoluciones.map((item,index)=>(
                      <TablaDevolucionesQxFarmacia key={index} item={item} validarEnfermeria={validarEnfermeria} dataEnfermeria={dataEnfermeria} actualizarData={actualizarData}/>
                    ))
                    :
                    <tbody >
                        <tr className="divide-y divide-slate-700">
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td><Loading/></td>
                          <td></td>
                          <td></td>                          
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                  }
                  {/* {
                      loading?
                      dataDescripcionQuirurgica.map((item,index)=>(
                        <TablaDescripcionQuirurgicaDQ key={index} item={item}/>
                      ))
                      :
                      <tbody className="divide-y divide-slate-700">
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><Loading/></td>
                      </tr>
                      </tbody>
                    }
                  */}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOnListaPersonalEnfermeria? <ModalListaPersonalEnfermeriaDevolucionesQx setmodalOnListaPersonalEnfermeria={setmodalOnListaPersonalEnfermeria} passDataEnfermeria={passDataEnfermeria}/>:null}
    </>
  )
}

export default DevolucionesQxFarmacia